import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import UIkit from 'uikit'
import VueScrollTo from 'vue-scrollto'
import VueCookies from 'vue-cookies-ts'
import { VueReCaptcha } from 'vue-recaptcha-v3'

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'

import { faArrowRight, faEuroSign, faDollarSign, faYenSign, faPoundSign, faCheck, faComment, faSignInAlt, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Vee-validate input validation
import { extend, configure, setInteractionMode } from 'vee-validate'
// Add validation rules
// eslint-disable-next-line camelcase
import { required, email, alpha_num, min_value, max, min } from 'vee-validate/dist/rules'
import IBAN from 'iban'
import CardValidator from 'card-validator'
// --------

import Axios from 'axios'
Axios.defaults.timeout = 8000
Axios.defaults.baseURL = window.ajax_params.url

Axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response
  }, function (error) {
    // // Any status codes that falls outside the range of 2xx cause this function to trigger
    // UIkit.notification({
    //   message: i18n.t('generalConnectionError'),
    //   status: 'danger',
    //   pos: 'top-center'
    // })
    return error
  }
)

Vue.prototype.$uikit = UIkit

Vue.config.productionTip = false

library.add(fab, faArrowRight, faEuroSign, faDollarSign, faYenSign, faPoundSign, faCheck, faComment, faSignInAlt, faInfoCircle)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.filter('replace', function (placeholder, newValue) {
  placeholder;
  newValue;
})

// Scoll to - see https://www.npmjs.com/package/vue-scrollto
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 800,
  easing: 'ease',
  offset: -92,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

// FILTERS
Vue.filter('currency', function (value, currency) {
  if (typeof currency === 'undefined') {
    currency = {
      factor: 1,
      symbol: '€',
      decimals: 2
    }
  }

  value = value * currency.factor
  return currency.symbol + ' ' + value.toFixed(currency.decimals).replace(/(\d)(?=(\d{3})+(,|$))/g, '$1,')
})

// Vue form input validation
// const dictionary = {
//   en: {
//     messages: {
//       email: () => 'invalid_email'
//     }
//   }
// }

// Validator.localize({ ...VeeMessages, ...dictionary })
// Vue.use(VeeValidate)

configure({
  classes: {
    valid: 'uk-form-success',
    invalid: 'uk-form-danger'
  },
  defaultMessage: (field, values) => {
    field;
    values;
    // values._field_ = i18n.t(`fields.${field}`);
    // return i18n.t(`validation.${values._rule_}`, values);
  }
})

extend('email', email)
extend('min_value', min_value)
extend('alpha_num', alpha_num)
extend('max', max)
extend('min', min)
extend('required', {
  ...required,
  message: (fieldName, placeholders) => {
    placeholders;
    switch (fieldName) {
      case 'postalCode':
      case 'street':
        // eslint-disable-next-line no-undef
        return i18n['step2-cityerror']

      default:
        return 'REQUIRED!'
    }
  }
})

extend('iban', {
  validate: (value) => {
    return IBAN.isValid(value)
  },
  message:
    'invalid_iban'
})

extend('credit_card', {
  validate: (value) => {
    var number = CardValidator.number(value)
    return number.isValid
  },
  message:
    'invalid_card_number'
})

setInteractionMode('aggressive') // see https://logaretm.github.io/vee-validate/guide/interaction-and-ux.html#interaction-modes

// Vue Cookie handler
Vue.use(VueCookies)

// reCaptcha V3
// eslint-disable-next-line
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#wp-vue-app')
